import { S3File } from './s3-file.interface';

export enum PdfJobStatus {
    WAITING = 'waiting',
    PROCESSING = 'processing',
    FINISHED = 'finished',
    ERROR = 'error',
}

export interface PdfJob {
    /**
     * The unique id of the pdf job
     */
    _id: string;
    /**
     * The name of the pdf job
     */
    name: string;
    /**
     * The status of the pdf job
     */
    status: PdfJobStatus;
    /**
     * Whether the pdf job has been seen
     */
    seen: boolean;
    /**
     * The html of the pdf job
     */
    html: string[];
    /**
     * The error message of the pdf job
     */
    errorMessage?: string;
    /**
     * The file of the pdf job
     */
    file?: S3File;
    /**
     * The company of the pdf job
     */
    company: string;

    /**
     * When this pdf job was created
     */
    createdAt: Date;
    /**
     * When this pdf job was last updated
     */
    updatedAt: Date;
    /**
     * Whether the pdf has been downloaded
     */
    downloaded?: boolean;
}
